import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { MergeTags } from '../../store/tags.action';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../../utils/validation.util";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";


@Component({
  selector: 'app-merge-tags-dialog',
  templateUrl: './merge-tags-dialog.component.html',
  styleUrls: ['./merge-tags-dialog.component.scss']
})
export class MergeTagsDialogComponent implements OnInit {
  tagsForMerge: Array<any> = [];
  mergeTagsForm: FormGroup;
  validationMsg = VALIDATION_MESSAGES;
  error: boolean = false
  specialCharregex
  multiSpaceRegex
  regExError: boolean = false

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private fb: FormBuilder,
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.mergeTagsForm = this.fb.group({
      newTagName: ["", Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])]
    });

    this.mergeTagsForm.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(((val) => {
      this.error = false;
      this.regExError = false
      if (val != null) {
        (typeof (val.newTagName) === 'number') ? val.toString() : val;
        let value = val.newTagName.trim();

        this.specialCharregex = new RegExp(/^[A-Za-z0-9 ]*[A-Za-z0-9][A-Za-z0-9 ]*$/);
        this.multiSpaceRegex = new RegExp(/[ ]{2,}/);

        if (this.specialCharregex.test(value)) {
          this.regExError = false;
        }
        else {
          this.error = false;
          this.regExError = true;

        }

        if (!this.multiSpaceRegex.test(value)) {
          this.error = false;
        }
        else {
          this.regExError = false;
          this.error = true;
        }
      }
    }))
  }



  mergeTags() {
    if (this.mergeTagsForm.invalid || (this.error == true)) {
      return false;
    }
    const payload = {
      tags: this.data.tagsSelectedForMerge,
      mergeTag: this.mergeTagsForm.value.newTagName
    };

    this.store.dispatch(new MergeTags(payload));
    this.dialogRef.close(true);
  }

  onCloseDialog(): void {
    this.dialogRef.close(false);
  }
}



